module.exports = __webpack_public_path__ + "img/anewitem-laptop.a724983a.svg";